export const WRITEOFF_ACTIVITY_LIST = {
	name: '商户下按活动核销统计',
	api: '${BASE}/bcp-coupon-dev/api/B/couponInstance/writeOffListByActivityId',
  method: 'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=26378327',
};

export const WRITEOFF_CATEGORY_LIST = {
	name: '商户下按券核销统计',
	api: '${BASE}/bcp-coupon-dev/api/B/couponInstance/writeOffListByCategoryId',
  method: 'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=26378324',
};

export const WRITEOFF_COUPON_COUNT = {
	name: '主体下领取和核销的券数量接口',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/entity/getAndWriteOffCount',
	method:'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=26378275',
};

export const WRITEOFF_ACTIVITY_COUNT = {
	name: '活动数',
	api: '${BASE}/bcp-coupon-dev/api/B/activity/entity/join/count',
	method:'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=26378262',
};

export const DAYORMONTH_WRITEOFF_COUNT = {
	name: '统计指定主体最近7天或者最近6个月的核销数接口',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/entity/dayOrMonthWriteOffCount',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=23463769',
};
